import React from "react";
import ReactGA from "react-ga4";
import { Grid, Typography } from "@mui/material";
import EventCard from "./components/EventCard";
import request from "../../utilities/requests";

const Home = () => {
  const [events, setEvents] = React.useState([]);

  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/",
      title: "Home",
    });
  }, []);

  React.useEffect(() => {
    const getEvents = async () => {
      const result = await request("events/dashboard");
      if (result.success) {
        setEvents(result.events);
      }
    };
    getEvents();
  }, []);

  return (
    <>
      <Grid container spacing={3} style={{ padding: 10 }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 50,
          }}
        >
          <Typography variant="h4">This Month's Events</Typography>
        </Grid>

        {events.map((event, i) => (
          <EventCard key={`${event._id}-${i}`} event={event} />
        ))}
      </Grid>
    </>
  );
};

export default Home;
